<template>
  <div class="">
    <div class="container pt-3 m-auto text-left ">
       
      <form autocomplete="off" class="form-horizontal" @submit.prevent="validateBeforeSubmit">

        
        <b-row>
          <b-col cols="12">
            <b-form-group id="input-titulo" label="Titulo:" label-for="titulo"> <!--description="We'll never share your email with anyone else."-->
              <b-form-input :disabled="true" id="titulo" type="text" v-model="logro.titulo"></b-form-input>
            </b-form-group>
            <b-form-group id="input-porcentaje" label="Porcentaje:" label-for="porcentaje">
              <b-input-group append="%"> <!--prepend="$"-->
                <b-form-input :disabled="true" step="0.01" id="porcentaje" type="number" v-model="logro.porcentaje"></b-form-input>
              </b-input-group>
            </b-form-group>

          </b-col>
        </b-row>

        <b-row class="mb-3 mt-2">
          <b-col cols="12">
            <button class="btn btn-block btn-secondary" type="button" @click="cerrar">Cerrar</button>
          </b-col>
        </b-row>
      </form>
      
    </div>
  </div>
  
</template>


<script>
  import {mapState, mapActions, mapMutations} from 'vuex';
  
  export default {
    name: 'LogroDetalle',
    components: {
      
    },
    data () {
      return {
        
      }
    },
    props: {
      logro:Object
    },
    mounted () {
     
    },
    
    methods:{
        ...mapActions({
            setWarning: 'setWarning',
        }),
      ...mapMutations({
        
      }),
      
      cerrar() {
        this.$emit("cerrar")
      }

    },
    computed:{
      ...mapState({
        detalle: state => state.temas.detalle, 
        warning: state => state.warning,
        detalle_curso: state => state.cursos.detalle, 
      }),

      curso(){
        return this.detalle_curso[this.curso_id]
      },
      
    }
    
  }
</script>

<style scope>

  .perfil_wrapper .container{
      background-color: #fff;
      padding: 15px;
  }
</style>
